import React from 'react';

import * as styles from './SmallBusinessLove.styles';

export const SmallBusinessLove = () => {
  return (
    <div css={styles.root}>
      <img
        alt=""
        src="https://images.contentstack.io/v3/assets/blt63f2f7afd19b09c2/blt9bb2cad5b6341498/6968c2e66c3ff300088590a2/parcel.png?width=90"
      />
      <p>
        <b>WITH LOVE</b>
        <br />
        Each small business hand-packs and posts their own orders
      </p>
    </div>
  );
};
